<template>
	<b-modal :no-close-on-backdrop="isLoading" :hide-header-close="isLoading" ref="modal" :title="title" :size="modalSize" class="modal-primary" @hidden="clearModalData">
		<loading :active.sync="isLoading" 
			:is-full-page="false"></loading>
		<b-row v-if=" mode === mode_SWITCH3">
			<b-col>
				<b-card :header="'Podatki o izdaji (#' + hotelStoritev.fk_hotel_storitev_take + ')'">
					<b-row class="mb-2">
						<b-col>
							<span v-html="takeOfSwitch"/>
						</b-col>
					</b-row>
				</b-card>
			</b-col>
		</b-row>
		<b-row v-show="mode === mode_GIVE1 || mode === mode_TAKE2 || mode === mode_SWITCH3 || mode === mode_EDITING4">
			<b-col>
				<b-card :header="mainCardHeader">
					<b-row>
						<b-col>
							<b-form-group
								label-for="input-num_tires"
								label="Št. pnevmatik">
									<b-form-input v-if="mode === mode_GIVE1 || mode === mode_SWITCH3 || mode === mode_EDITING4" :disabled="formDisabled" v-model="hotelStoritev.num_tires" id="input-num_tires" type="number" min="1"></b-form-input>
									<b-form-input v-if="mode === mode_TAKE2" :value="hotelStoritev.num_tires" disabled></b-form-input>
							</b-form-group>
						</b-col>
						<b-col>
							<b-form-group
								label-for="input-manufacturer"
								label="Znamka:">
									<v-select v-if="(mode === mode_GIVE1 || mode === mode_SWITCH3 || mode === mode_EDITING4) && manufacturer_Options.length > 0"
										v-model="hotelStoritev.manufacturer"
										:options="manufacturer_Options"
										:taggable="true"
										:filterable="false"
										placeholder="Izberi znamko gume..."
										:disabled="mode === mode_TAKE2 || formDisabled"
										@search="manufacturerSearch">
										<template slot="no-options">Ni znamk gum</template>
									</v-select>
									<b-form-input v-else-if="mode === mode_TAKE2 || formDisabled"  type="text" :value="hotelStoritev.manufacturer" disabled></b-form-input>
									<b-form-input v-else type="text" v-model="hotelStoritev.manufacturer"></b-form-input>
									</b-form-group>
						</b-col>
					</b-row>
					<b-row>
						<b-col cols="4">
							<b-card :header="'Dimenzije: ' + hotelStoritev.dimensions.width  + '/' + hotelStoritev.dimensions.heigth + 'R' + hotelStoritev.dimensions.diameter" class="infoCard">
								<b-row>
									<b-col>
										<b-form-group 
											:invalid-feedback="invalidFeedback_dimensions_width"
											:state="state_dimensions_width"
											label="Širina:"
											label-cols="4">
											<b-form-input type="number"
												v-model="hotelStoritev.dimensions.width"
												:disabled="mode === mode_TAKE2 || formDisabled">
											</b-form-input>
										</b-form-group>
									</b-col>
								</b-row>
								<b-row>
									<b-col>
										<b-form-group
											:invalid-feedback="invalidFeedback_dimensions_height"
											:state="state_dimensions_height"
											label="Višina:"
											label-cols="4">
											<b-form-input type="number"
												v-model="hotelStoritev.dimensions.heigth"
												placeholder="Vnesite višino ..."
												:disabled="mode === mode_TAKE2 || formDisabled">
											</b-form-input>
										</b-form-group>
									</b-col>
								</b-row>
								<b-row>
									<b-col>
										<b-form-group
											:invalid-feedback="invalidFeedback_dimensions_diameter"
											:state="state_dimensions_diameter"
											label="Premer:"
											label-cols="4">
											<b-form-input type="number"
												v-model="hotelStoritev.dimensions.diameter"
												placeholder="Vnesite premer ..."
												:disabled="mode === mode_TAKE2 || formDisabled">
											</b-form-input>
										</b-form-group>
									</b-col>
								</b-row>
							</b-card>
						</b-col>
						<b-col>	
							<b-row>
								<b-col>
									<b-card header="Sezona" class="infoCard">
										<b-form-group>
											<b-form-radio-group v-model="hotelStoritev.season" 
												:options="settings.season_options"
												stacked
												:disabled="mode === mode_TAKE2 || formDisabled">
											</b-form-radio-group>
										</b-form-group>
									</b-card>
								</b-col>
								<b-col>
									<b-card header="Platišča" class="infoCard">
										<b-form-group>
											<b-form-radio-group v-model="hotelStoritev.rims"
												:options="settings.rims_options"
												stacked
												:disabled="mode === mode_TAKE2 || formDisabled">
											</b-form-radio-group>
											<b-form-checkbox @change="rimsCover_Changed" :checked="hotelStoritev.rims_cover === 1" class="mt-2" :disabled="mode === mode_TAKE2 || formDisabled">Pokrovi</b-form-checkbox>
											<b-form-checkbox @change="rimsScrew_Changed" :checked="hotelStoritev.rims_screw === 1" :disabled="mode === mode_TAKE2 || formDisabled">Vijaki</b-form-checkbox>
										</b-form-group>
									</b-card>
								</b-col>
							</b-row>
						</b-col>
					</b-row>
					<b-row v-if="mode === mode_GIVE1 || mode === mode_TAKE2 || mode === mode_EDITING4">
						<b-col>
							<b-form-group
								label-for="input-date_give"
								:invalid-feedback="invalidFeedback_date_give"
								:state="state_date_give"
								label="Datum oddaje:">
								<b-form-input v-if="mode === mode_TAKE2 || formDisabled"  type="text" :value="hotelStoritev.date_give | hr_date" disabled></b-form-input>
								<v-date-picker v-else
									v-model="hotelStoritev.date_give"
									:max-date="new Date(Date.now())"
									:input-props='{
										class: "form-control dt_border gdt_border",
										placeholder: "DD. MM. YYYY"
									}'
									mode="single"
									locale="sl-SI" />
							</b-form-group>
						</b-col>
						<b-col>
							<b-form-group
								label-for="input-responsible_mechanic_give"
								:invalid-feedback="invalidFeedback_responsible_mechanic_give"
								:state="state_responsible_mechanic_give"
								label="Odgovorni mehanik:">
									<b-form-input :disabled="mode === mode_TAKE2 || formDisabled" v-model="hotelStoritev.responsible_mechanic_give" id="input-responsible_mechanic_give" placeholder="Ime in priimek odgovornega mehanika" ></b-form-input>
								</b-form-group>
						</b-col>
					</b-row>
					<b-row v-if="mode === mode_TAKE2 || mode === mode_EDITING4">
						<b-col>
							<b-form-group
								label-for="input-date_take"
								:invalid-feedback="invalidFeedback_date_take"
								:state="state_date_take"
								label="Datum izdaje:">
								<b-form-input v-if="formDisabled"  type="text" :value="hotelStoritev.date_give | hr_date" disabled></b-form-input>
								<v-date-picker v-else
									v-model="hotelStoritev.date_take"
									:min-date="hotelStoritev.date_give"
									:max-date="new Date(Date.now())"
									:input-props='{
										class: "form-control dt_border gdt_border",
										placeholder: "DD. MM. YYYY"
									}'
									mode="single"
									locale="sl-SI" />
							</b-form-group>
						</b-col>
						<b-col>
							<b-form-group
								label-for="input-responsible_mechanic_take"
								:invalid-feedback="invalidFeedback_responsible_mechanic_take"
								:state="state_responsible_mechanic_take"
								label="Odgovorni mehanik:">
									<b-form-input :disabled="formDisabled" v-model="hotelStoritev.responsible_mechanic_take" id="input-responsible_mechanic_take" placeholder="Ime in priimek odgovornega mehanika" ></b-form-input>
								</b-form-group>
						</b-col>
					</b-row>
					<b-row v-if="mode === mode_SWITCH3">
						<b-col>
							<b-form-group
								label-for="input-date_give"
								:invalid-feedback="invalidFeedback_date_give"
								:state="state_date_give"
								label="Datum zamenjave:">
								<b-form-input v-if="formDisabled"  type="text" :value="hotelStoritev.date_give | hr_date" disabled></b-form-input>
								<v-date-picker v-else
									v-model="hotelStoritev.date_give"
									:min-date="takeOfSwitch_date_give"
									:max-date="new Date(Date.now())"
									:input-props='{
										class: "form-control dt_border gdt_border",
										placeholder: "DD. MM. YYYY"
									}'
									mode="single"
									locale="sl-SI" />
							</b-form-group>
						</b-col>
						<b-col>
							<b-form-group
								label-for="input-responsible_mechanic_give"
								:invalid-feedback="invalidFeedback_responsible_mechanic_give"
								:state="state_responsible_mechanic_give"
								label="Odgovorni mehanik:">
									<b-form-input :disabled="formDisabled" v-model="hotelStoritev.responsible_mechanic_give" id="input-responsible_mechanic_give" placeholder="Ime in priimek odgovornega mehanika" ></b-form-input>
								</b-form-group>
						</b-col>
					</b-row>
				</b-card>
				<b-card v-if="mode === mode_GIVE1 || mode === mode_TAKE2 || mode === mode_SWITCH3 || mode === mode_EDITING4">
					<div slot="header">
						<b-row>
							<b-col>
								Komentarji <span class="ml-2"></span>
							</b-col>
						</b-row>
					</div>
					<b-row v-if="!formDisabled">
						<b-col cols=10>
							<b-form-group
								label-for="input-hotel_komentar_content">
								<b-form-textarea :disabled="formDisabled" v-model="hotelKomentar.content" id="input-hotel_komentar_content" placeholder="Vnesite komentar" type="text" :rows="3"></b-form-textarea>
							</b-form-group>
						</b-col>
						<b-col cols=2>
							<b-button :disabled="addHotelKomentarButton.disabled || hotelKomentar.content == null || hotelKomentar.content === ''" :title="hotelKomentar.content == null || hotelKomentar.content === '' ? 'Komentar mora imeti vsebino' : 'Dodaj komentar'" variant="primary" @click.stop="addHotelKomentar()">{{ addHotelKomentarButton.label }}
								<b-spinner small v-if="addHotelKomentarButton.progress"></b-spinner>
							</b-button>
						</b-col>
					</b-row>
					<b-row>
						<b-col>
						<b-table
							v-show="false"
							ref="komentarjiOfStoritevTable"
							responsive="sm"
							striped
							show-empty
							hover
							:empty-text="komentarjiOfStoritevTable_props.empty_text"
							:empty-filtered-text="komentarjiOfStoritevTable_props.empty_filtered_text"
							:sort-desc="true"
							:current-page="komentarjiOfStoritevTable_props.page"
							:per-page="komentarjiOfStoritevTable_props.size"
							:fields="komentarjiOfStoritevTable_props.fields"
							:items="komentarjiOfStoritevTable_items">
							<template slot="user" slot-scope="data">
								{{ data.item.first_name }} {{ data.item.last_name }}
							</template>
							<template slot="created_at" slot-scope="data">
								{{ data.item.created_at | hr_datetime }}
							</template>
							<template slot="content" slot-scope="data">
								<div>{{ data.item.content }}</div>
							</template>
						</b-table>
						<div v-for="item in komentarjiOfStoritevTable_props.items" :key="item.id">
							<div align="center">
								{{ item.created_at | hr_datetime }}
							</div>
							<div class="comment mb-3">
								<b>{{ item.first_name }}:</b> {{ item.content }}
							
							</div>
						</div>
						<nav class="nav">
							<b-row>
								<b-col>
									<b-pagination :total-rows="komentarjiOfStoritevTable_props.total" :per-page="komentarjiOfStoritevTable_props.size" v-model="komentarjiOfStoritevTable_props.page" prev-text="Prejšnja" next-text="Naslednja" hide-goto-end-buttons />
								</b-col>
								<b-col>
									<a class="page-link rows_total">Št. vrstic: {{ komentarjiOfStoritevTable_props.total }}</a>
								</b-col>
								<b-col>
									<b-form-select v-model="komentarjiOfStoritevTable_props.size" :options="komentarjiOfStoritevTable_props.options_numRowsOnPage"></b-form-select>
								</b-col>
							</b-row>
						</nav>
						</b-col>
					</b-row>
				</b-card>
			</b-col>
		</b-row>
		<b-alert :variant="message.type" :show="message.text && message.text !== ''">{{ message.text }}</b-alert>
		<template slot="modal-footer" slot-scope="{ cancel }">
			<b-container fluid class="p-0">
				<b-row>
					<b-col align-self="end" class="ma_pos">
						<b-button :disabled="isLoading" style="margin-right:5px;" variant="secondary" @click="cancel()">Prekliči</b-button>
						<b-button v-if="!formDisabled" :disabled="okButton.disabled" variant="primary" @click.stop="onOkModal()">{{ okButton.label }}
							<b-spinner small v-if="okButton.progress"></b-spinner>
						</b-button>
					</b-col>
				</b-row>
			</b-container>
		</template>
	</b-modal>
</template>

<script>
import service from '@/service';
import settings from '@/settings.js';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import { parse } from 'date-fns';

export default {
	name: 'edit-hotel-storitev-modal',
	components: {
		Loading
	},
	props: {
		hotelStoritevDistincManufacturers: {
			type: Array,
			required: false
		}
	},
	methods: {
		showModal: function (modalInput) {
			/*
				mode 1 => Adding new give
				mode 2 => Adding new take
				mode 3 => Adding new switch
				mode 4 => Edit hotel storitev
			*/
			this.mode = modalInput.mode;
			this.initModal(modalInput.hotelStoritev, modalInput.hotelHramba);
		},
		initModal: function (hotelStoritev, hotelHramba) {
			if (this.mode === this.mode_GIVE1) {
				this.komentarjiOfStoritevTable_props.inputFilter.linked_to = -1;
				if (!hotelHramba.id || hotelHramba.id < 1) {
					this.title = 'Napaka';
					this.mode = this.mode_UNKNOWN0;
					this.showAlert('Napaka: neveljavna hramba');
				} else {
					this.hotelStoritev.fk_hotel_hramba = hotelHramba.id;
					this.hotelStoritev.fk_hotel_stranka = hotelHramba.fk_hotel_stranka;
					this.hotelStoritev.num_tires = 4;
					this.hotelStoritev.dimensions = {
						width: '205',
						heigth: '55',
						diameter: '16'
					};
					this.hotelStoritev.season = 'L';
					this.hotelStoritev.rims = 'BREZ';
					this.hotelStoritev.date_give = new Date();
					this.title = 'Oddaja pnevmatik v hrambo #' + this.hotelStoritev.fk_hotel_hramba;
					this.okButton.label = 'Dodaj';
				}
			} else if (this.mode === this.mode_TAKE2) {
				this.hotelKomentar.linked_to = hotelStoritev.id;
				this.komentarjiOfStoritevTable_props.inputFilter.linked_to = hotelStoritev.id;
				if (!hotelStoritev) {
					this.title = 'Napaka';
					this.mode = this.mode_UNKNOWN0;
					this.showAlert('Napaka: neveljavna hramba ali storitev');
				} else {
					this.initHotelStoritev(hotelStoritev, hotelHramba);
					this.title = 'Izdaja pnevmatik #' + this.hotelStoritev.id;
					this.okButton.label = 'Izdaj';
				}
			} else if (this.mode === this.mode_SWITCH3) {
				this.komentarjiOfStoritevTable_props.inputFilter.linked_to = -1;
				if (!hotelStoritev) {
					this.title = 'Napaka';
					this.mode = this.mode_UNKNOWN0;
					this.showAlert('Napaka: neveljavna hramba ali storitev');
				} else {
					this.inittakeOfSwitch(hotelStoritev);
					this.hotelStoritev.fk_hotel_hramba = hotelHramba.id;
					this.hotelStoritev.fk_hotel_stranka = hotelHramba.fk_hotel_stranka;
					this.hotelStoritev.num_tires = 4;
					this.hotelStoritev.dimensions = {
						width: '205',
						heigth: '55',
						diameter: '16'
					};
					this.hotelStoritev.season = 'L';
					this.hotelStoritev.rims = 'BREZ';
					this.hotelStoritev.date_give = new Date();
					this.title = 'Zamenjava pnevmatik #' + hotelStoritev.id;
					this.okButton.label = 'Zamenjaj';
				}
			} else if (this.mode === this.mode_EDITING4) {
				this.hotelKomentar.linked_to = hotelStoritev.id;
				this.komentarjiOfStoritevTable_props.inputFilter.linked_to = hotelStoritev.id;
				if (!hotelStoritev) {
					this.title = 'Napaka';
					this.mode = this.mode_UNKNOWN0;
					this.showAlert('Napaka: neveljavna hramba ali storitev');
				} else {
					this.initHotelStoritev(hotelStoritev, hotelHramba);
					this.title = 'Urejanje storitve #' + this.hotelStoritev.id;
					this.okButton.label = 'Shrani';
				}
			} else {
				this.mode = this.mode_UNKNOWN0;
				this.title = 'Neznan način';
				this.okButton.label = 'Zapri';
			}
			this.$refs.modal.show();
		},
		initHotelStoritev: function (hotelStoritev, hotelHramba) {
			this.hotelStoritev.id = hotelStoritev.id;
			this.hotelStoritev.fk_hotel_hramba = hotelStoritev.fk_hotel_hramba;
			this.hotelStoritev.fk_hotel_stranka = hotelHramba.fk_hotel_stranka;
			this.hotelStoritev.num_tires = hotelStoritev.num_tires;
			this.hotelStoritev.dimensions = JSON.parse(hotelStoritev.dimensions);
			this.hotelStoritev.manufacturer = hotelStoritev.manufacturer;
			this.hotelStoritev.season = hotelStoritev.season;
			this.hotelStoritev.rims = hotelStoritev.rims;
			this.hotelStoritev.rims_cover = hotelStoritev.rims_cover;
			this.hotelStoritev.rims_screw = hotelStoritev.rims_screw;
			this.hotelStoritev.year = hotelStoritev.year;
			this.hotelStoritev.wear = hotelStoritev.wear;
			this.hotelStoritev.note_give = hotelStoritev.note_give;
			this.hotelStoritev.responsible_mechanic_give = hotelStoritev.responsible_mechanic_give;
			this.hotelStoritev.date_give = hotelStoritev.date_give != null ? parse(hotelStoritev.date_give, settings.dbDtFormat) : null;
			if (this.mode === this.mode_TAKE2) {
				this.hotelStoritev.date_take = new Date();
			} else if (this.mode === this.mode_EDITING4) {
				this.hotelStoritev.note_take = hotelStoritev.note_take;
				this.hotelStoritev.responsible_mechanic_take = hotelStoritev.responsible_mechanic_take;
				this.hotelStoritev.date_take = hotelStoritev.date_take != null ? parse(hotelStoritev.date_take, settings.dbDtFormat) : null;
			}
		},
		inittakeOfSwitch: function (hotelStoritev) {
			this.hotelStoritev.fk_hotel_storitev_take = hotelStoritev.id;
			this.takeOfSwitch_date_give = hotelStoritev.date_give;
			let lastComment = '';
			if (hotelStoritev.hotel_komentarji.length > 0) {
				lastComment += hotelStoritev.hotel_komentarji[0].content;
			} else {
				lastComment += ' / ';
			}
			let manufacturer = hotelStoritev.manufacturer != null || hotelStoritev.manufacturer === '' ? hotelStoritev.manufacturer : ' - ';
			this.takeOfSwitch = 'Izdaja <b>' + hotelStoritev.num_tires + ' ' + this.getSeasonLabel(hotelStoritev) + '</b> gum <b>' + this.getDemensionsLabel(hotelStoritev) + '</b>,' + this.getRimsLabel(hotelStoritev) + '<b>' + this.getRimsAditionalLabel(hotelStoritev) + '</b> znamke <b>' + manufacturer + '</b>' +
			'<br> Zadnji komentar: ' + lastComment;
		},
		getDemensionsLabel: function (item) {
			let dimensions = JSON.parse(item.dimensions);
			return dimensions.width + '/' + dimensions.heigth + 'R' + dimensions.diameter;
		},
		getSeasonLabel: function (item) {
			if (item.season === 'L') {
				return 'letnih';
			} else if (item.season === 'Z') {
				return 'zimskih';
			} else if (item.season === 'ZL') {
				return 'celoletnih';
			} else {
				return '';
			}
		},
		getRimsLabel: function (item) {
			if (item.rims === 'BREZ') {
				return ' <b>brez platišč</b> ';
			} else if (item.rims === 'ALU') {
				return ' z <b>ALU platišči</b> ';
			} else if (item.rims === 'FE') {
				return ' z <b>platišči</b> ';
			} else {
				return '';
			}
		},
		getRimsAditionalLabel: function (item) {
			let label = '';
			if (item.rims_cover === 1 && item.rims_screw === 1) {
				label = '(S pokrovi in vijaki)';
			} else if (item.rims_cover === 1) {
				label = '(S pokrovi)';
			} else if (item.rims_screw === 1) {
				label = '(Z vijaki)';
			}
			return label;
		},
		onOkModal: function () {
			if (this.mode === this.mode_GIVE1 || this.mode === this.mode_TAKE2 || this.mode === this.mode_SWITCH3 || this.mode === this.mode_EDITING4) {
				if (this.validateForm) {
					this.startProgress();
					this.hideAlert();
					service.hotelStoritevEdit(this.hotelStoritev, this.mode, this.komentarjiOfStoritevTable_props.items)
						.then(responseData => {
							if (responseData.message === 'addedGive' || responseData.message === 'addedTake' || responseData.message === 'addedSwitch' || responseData.message === 'editing') {
								this.$emit('emit_success', responseData.hotelStoritev, this.mode);
								this.$refs.modal.hide();
							} else {
								this.showAlert('Neveljaven odziv strežnika!', this.ALERT_TYPE_ERROR);
								console.error('Neveljaven response message: ' + responseData.message);
							}
							this.stopProgress();
						})
						.catch(error => {
							this.stopProgress();
							if (error.response) {
							// Request made and server responded
								if (error.response.status === 400) {
									if (error.response.data.internalCode === 600) {
										this.showAlert({message: 'Neznana napaka na strežniku!', type: this.ALERT_TYPE_ERROR});
										console.error(error.response.data.message);
									} else if (error.response.data.internalCode === 601) {
										this.showAlert({message: 'Napaka pri podatkovni bazi!', type: this.ALERT_TYPE_ERROR});
										console.error(error.response.data.message);
									} else if (error.response.data.internalCode === 602) {
										this.showAlert({message: 'Uporabnik nima dostopa do hotela gum!', type: this.ALERT_TYPE_ERROR});
										console.error(error.response.data.message);
									} else if (error.response.data.internalCode === 603) {
										this.showAlert({message: 'Napaka pri validaciji na strežniku!', type: this.ALERT_TYPE_ERROR});
										console.error(error.response.data.message);
									} else if (error.response.data.internalCode === 604) {
										this.showAlert({message: 'Hramba ni najdena!', type: this.ALERT_TYPE_ERROR});
										console.error(error.response.data.message);
									} else if (error.response.data.internalCode === 605) {
										this.showAlert({message: 'Neuspešno shranjevanje hrambe!', type: this.ALERT_TYPE_ERROR});
										console.error(error.response.data.message);
									} else {
										this.showAlert({message: 'Neznana napaka na strežniku (status: ' + error.response.status + ')!', type: this.ALERT_TYPE_ERROR});
										console.error(error.response.data.internalCode, error.response.data.message);
									}
								} else {
									this.showAlert({message: 'Neznana napaka na strežniku (status: ' + error.response.status + ')!', type: this.ALERT_TYPE_ERROR});
									console.error(error.response.status, error.response.data.message);
								}
							} else if (error.request) {
								// The request was made but no response was received
								this.showAlert({message: 'Napaka: strežnik se ni odzval!', type: this.ALERT_TYPE_ERROR});
								console.error('The request was made but no response was received:', error.request);
							} else {
								// Something happened in setting up the request that triggered an Error
								this.showAlert({message: 'Napaka pri pošiljanju zahteve na strežnik!', type: this.ALERT_TYPE_ERROR});
								console.error('Something happened in setting up the request that triggered an Error:', error.message);
							}
						});
				} else {
					this.showAlert({message: 'Nepravilno izpolnjen obrazec!', type: this.ALERT_TYPE_ERROR});
					this.stopProgress();
				}
			} else {
				this.$refs.modal.hide();
			}
		},
		clearModalData: function () {
			this.title = '';
			this.stopProgress();
			this.okButton.label = '';
			this.message.type = null;
			this.message.text = null;
			this.mode = this.mode_UNKNOWN0;
			this.hotelHramba = null
			this.hotelStoritev = {
				id: 0,
				fk_hotel_hramba: null,
				fk_hotel_stranka: null,
				num_tires: null,
				dimensions: {
					width: null,
					heigth: null,
					diameter: null
				},
				manufacturer: null,
				season: null,
				rims: null,
				rims_cover: 0,
				rims_screw: 0,
				year: null,
				wear: null,
				note_give: null,
				responsible_mechanic_give: null,
				date_give: null,
				note_take: null,
				responsible_mechanic_take: null,
				date_take: null,
				fk_hotel_storitev_take: null
			};
			this.hotelKomentar = {
				id: 0,
				linked_to: null,
				content: null
			};
			this.takeOfSwitch = null;
			this.takeOfSwitch_date_give = null;
			this.komentarjiOfStoritevTable_props.page = 1;
			this.komentarjiOfStoritevTable_props.size = 5;
			this.komentarjiOfStoritevTable_props.total = 0;
			this.komentarjiOfStoritevTable_props.isLoading = 0;
			this.komentarjiOfStoritevTable_props.inputFilter.linked_to = null;
			this.komentarjiOfStoritevTable_props.items = [];
		},
		startProgress: function () {
			this.isLoading = true;
			this.okButton.disabled = true;
			this.okButton.progress = true;
		},
		stopProgress: function () {
			this.isLoading = false;
			this.okButton.disabled = false;
			this.okButton.progress = false;
		},
		startKomentarProgress: function () {
			this.isLoading = true;
			this.addHotelKomentarButton.disabled = true;
			this.addHotelKomentarButton.progress = true;
		},
		stopKomentarProgress: function () {
			this.isLoading = false;
			this.addHotelKomentarButton.disabled = false;
			this.addHotelKomentarButton.progress = false;
		},
		showAlert: function (alert) {
			let targetMessage = this.message;
			if (alert.message && alert.type && alert.seconds) {
				targetMessage.type = alert.type;
				targetMessage.text = alert.message;
				setTimeout(() => {
					this.hideAlert(alert.target);
				}, alert.seconds * 1000);
			} else if (alert.message && alert.type) {
				targetMessage.type = alert.type;
				targetMessage.text = alert.message;
			} else if (alert.message) {
				targetMessage.type = 'primary';
				targetMessage.text = alert.message;
			} else {
				targetMessage.type = null;
				targetMessage.text = null;
			}
		},
		hideAlert: function (target) {
			let targetMessage = this.message;
			targetMessage.type = null;
			targetMessage.text = null;
		},
		loadManufacturers: function () {
			this.manufacturer_initOptions = [];
			service.hotelStoritevInitParams({ 'manufacturer': true })
				.then(responseData => {
					if (responseData.message === 'success') {
						this.manufacturer_initOptions = responseData.distinctManufacturers;
					} else {
						console.error('Neveljaven odziv strežnika: ', responseData.message);
					}
				})
				.catch(error => {
					if (error.response) {
						// Request made and server responded
						if (error.response.status === 400) {
							if (error.response.data.internalCode === 600) {
								console.error(error.response.data.message);
							} else if (error.response.data.internalCode === 601) {
								console.error(error.response.data.message);
							} else if (error.response.data.internalCode === 602) {
								console.error(error.response.data.message);
							} else if (error.response.data.internalCode === 603) {
								console.error(error.response.data.message);
							} else {
								console.error(error.response.data.internalCode, error.response.data.message);
							}
						} else {
							console.error(error.response.status, error.response.data.message);
						}
					} else if (error.request) {
						// The request was made but no response was received
						console.error('The request was made but no response was received:', error.request);
					} else {
						// Something happened in setting up the request that triggered an Error
						console.error('Something happened in setting up the request that triggered an Error:', error.message);
					}
				});
		},
		addHotelKomentar: function () {
			if (this.mode === this.mode_GIVE1 || this.mode === this.mode_SWITCH3) {
				this.komentarjiOfStoritevTable_props.items.unshift({'created_at': new Date(), 'first_name': this.user.first_name, 'content': this.hotelKomentar.content});
				this.hotelKomentar.id = 0;
				this.hotelKomentar.content = null;
			} else {
				this.startKomentarProgress();
				this.hideAlert();
				service.hotelKomentarEdit(this.hotelKomentar)
					.then(responseData => {
						if (responseData.message === 'added') {
							this.$emit('emit_comment_added');
							this.$refs.komentarjiOfStoritevTable.refresh();
							this.hotelKomentar.id = 0;
							this.hotelKomentar.content = null;
						} else {
							this.showAlert('Neveljaven odziv strežnika!', this.ALERT_TYPE_ERROR);
							console.error('Neveljaven response message: ' + responseData.message);
						}
						this.stopKomentarProgress();
					})
					.catch(error => {
						this.stopKomentarProgress();
						if (error.response) {
						// Request made and server responded
							if (error.response.status === 400) {
								if (error.response.data.internalCode === 600) {
									this.showAlert({message: 'Neznana napaka na strežniku!', type: this.ALERT_TYPE_ERROR});
									console.error(error.response.data.message);
								} else if (error.response.data.internalCode === 601) {
									this.showAlert({message: 'Napaka pri podatkovni bazi!', type: this.ALERT_TYPE_ERROR});
									console.error(error.response.data.message);
								} else if (error.response.data.internalCode === 602) {
									this.showAlert({message: 'Uporabnik nima dostopa do hotela gum!', type: this.ALERT_TYPE_ERROR});
									console.error(error.response.data.message);
								} else if (error.response.data.internalCode === 603) {
									this.showAlert({message: 'Napaka pri validaciji na strežniku!', type: this.ALERT_TYPE_ERROR});
									console.error(error.response.data.message);
								} else if (error.response.data.internalCode === 604) {
									this.showAlert({message: 'Komentar ni najden!', type: this.ALERT_TYPE_ERROR});
									console.error(error.response.data.message);
								} else if (error.response.data.internalCode === 605) {
									this.showAlert({message: 'Neuspešno shranjevanje komentarja!', type: this.ALERT_TYPE_ERROR});
									console.error(error.response.data.message);
								} else {
									this.showAlert({message: 'Neznana napaka na strežniku (status: ' + error.response.status + ')!', type: this.ALERT_TYPE_ERROR});
									console.error(error.response.data.internalCode, error.response.data.message);
								}
							} else {
								this.showAlert({message: 'Neznana napaka na strežniku (status: ' + error.response.status + ')!', type: this.ALERT_TYPE_ERROR});
								console.error(error.response.status, error.response.data.message);
							}
						} else if (error.request) {
							// The request was made but no response was received
							this.showAlert({message: 'Napaka: strežnik se ni odzval!', type: this.ALERT_TYPE_ERROR});
							console.error('The request was made but no response was received:', error.request);
						} else {
							// Something happened in setting up the request that triggered an Error
							this.showAlert({message: 'Napaka pri pošiljanju zahteve na strežnik!', type: this.ALERT_TYPE_ERROR});
							console.error('Something happened in setting up the request that triggered an Error:', error.message);
						}
					});
			}
		},
		komentarjiOfStoritevTable_items: function (ctx) {
			this.komentarjiOfStoritevTable_props.isLoading = true;
			return service.getHotelKomentarjiFiltered(ctx, this.komentarjiOfStoritevTable_props.inputFilter)
				.then(responseData => {
					this.komentarjiOfStoritevTable_props.isLoading = false;
					if (responseData.message === 'success') {
						this.komentarjiOfStoritevTable_props.empty_text = 'Ni komentarjev';
						this.komentarjiOfStoritevTable_props.total = responseData.items.total;
						this.komentarjiOfStoritevTable_props.items = responseData.items.data;
						return responseData.items.data;
					} else {
						this.showAlert('Neznana odziv strežnika!', this.ALERT_TYPE_ERROR);
						this.komentarjiOfStoritevTable_props.empty_text = 'Napaka pri pridobivanju storitev komentarjev';
						this.komentarjiOfStoritevTable_props.total = 0;
						console.error('Neveljaven odziv strežnika: ', responseData.message);
						return [];
					}
				})
				.catch(error => {
					this.komentarjiOfStoritevTable_props.isLoading = false;
					if (error.response) {
					// Request made and server responded
						if (error.response.status === 400) {
							if (error.response.data.internalCode === 600) {
								this.showAlert('Neznana napaka na strežniku!', this.ALERT_TYPE_ERROR);
								console.error(error.response.data.message);
							} else if (error.response.data.internalCode === 601) {
								this.showAlert('Napaka pri podatkovni bazi!', this.ALERT_TYPE_ERROR);
								console.error(error.response.data.message);
							} else if (error.response.data.internalCode === 602) {
								this.showAlert('Uporabnik nima dostopa do hotela gum!', this.ALERT_TYPE_ERROR);
								console.error(error.response.data.message);
							} else if (error.response.data.internalCode === 603) {
								this.showAlert('Napaka pri validaciji na strežniku!', this.ALERT_TYPE_ERROR);
								console.error(error.response.data.message);
							} else {
								this.showAlert('Neznana napaka na strežniku (status: ' + error.response.status + ')!', this.ALERT_TYPE_ERROR);
								console.error(error.response.data.internalCode, error.response.data.message);
							}
						} else {
							this.showAlert('Neznana napaka na strežniku (status: ' + error.response.status + ')!', this.ALERT_TYPE_ERROR);
							console.error(error.response.status, error.response.data.message);
						}
					} else if (error.request) {
						// The request was made but no response was received
						this.showAlert('Napaka: strežnik se ni odzval!', this.ALERT_TYPE_ERROR);
						console.error('The request was made but no response was received:', error.request);
					} else {
						// Something happened in setting up the request that triggered an Error
						this.showAlert('Napaka pri pošiljanju zahteve na strežnik!', this.ALERT_TYPE_ERROR);
						console.error('Something happened in setting up the request that triggered an Error:', error.message);
					}
				});
		},
		rimsCover_Changed () {
			this.hotelStoritev.rims_cover = this.hotelStoritev.rims_cover === 1 ? 0 : 1;
		},
		rimsScrew_Changed () {
			this.hotelStoritev.rims_screw = this.hotelStoritev.rims_screw === 1 ? 0 : 1;
		},
		manufacturerSearch: function (data) {
			if (data !== '') {
				this.hotelStoritev.manufacturer = data;
			}
		}
	},
	data: function () {
		return {
			isLoading: false,
			title: '',
			okButton: {
				label: '',
				progress: false,
				disabled: false
			},
			message: {
				type: null,
				text: null
			},
			ALERT_TYPE_SUCCESS: 'success',
			ALERT_TYPE_ERROR: 'danger',
			mode_UNKNOWN0: 0,
			mode_GIVE1: 1,
			mode_TAKE2: 2,
			mode_SWITCH3: 3,
			mode_EDITING4: 4,
			mode: 0,
			hotelHramba: null,
			hotelLokacija: null,
			hotelStoritev: {
				id: 0,
				fk_hotel_hramba: null,
				fk_hotel_stranka: null,
				num_tires: null,
				dimensions: {
					width: null,
					heigth: null,
					diameter: null
				},
				manufacturer: null,
				season: null,
				rims: null,
				rims_cover: 0,
				rims_screw: 0,
				year: null,
				wear: null,
				note_give: null,
				responsible_mechanic_give: null,
				date_give: null,
				note_take: null,
				responsible_mechanic_take: null,
				date_take: null,
				fk_hotel_storitev_take: null
			},
			settings,
			takeOfSwitch: null,
			takeOfSwitch_date_give: null,
			manufacturer_initOptions: null,
			hotelKomentar: {
				id: 0,
				linked_to: null,
				content: null
			},
			addHotelKomentarButton: {
				label: 'Dodaj',
				progress: false,
				disabled: false
			},
			komentarjiOfStoritevTable_props: {
				fields: [
					{ key: 'created_at', label: 'Dodan', sortable: true, class: 'tdHotelKomentarCreatedAt' },
					{ key: 'user', label: 'Uporabnik', sortable: true, class: 'tdHotelKomentarUser' },
					{ key: 'content', label: 'Vsebina', sortable: true, class: 'tdHotelKomentarContent' }
				],
				empty_text: '',
				empty_filtered_text: 'Ni zadetkov',
				page: 1,
				size: 5,
				total: 0,
				isLoading: false,
				inputFilter: {
					linked_to: null
				},
				options_numRowsOnPage: [
					{ value: 5, text: '5' },
					{ value: 10, text: '10' },
					{ value: 50, text: '50' }
				],
				items: []
			},
			localKomentarjiOfStoritevTable: []
		}
	},
	watch: {
	},
	computed: {
		user () {
			return this.$store.getters.user;
		},
		state_responsible_mechanic_give () {
			if (this.hotelStoritev.responsible_mechanic_give && this.hotelStoritev.responsible_mechanic_give.length > 0) {
				return true;
			}
			return false;
		},
		invalidFeedback_responsible_mechanic_give () {
			if (this.hotelStoritev.responsible_mechanic_give || this.formDisabled) {
				this.hideAlert();
				return '';
			}
			return 'Odgovoren mehanik je obvezen';
		},
		state_date_give () {
			if (this.hotelStoritev.date_give) {
				return true;
			}
			return false;
		},
		invalidFeedback_date_give () {
			if (this.hotelStoritev.date_give || this.formDisabled) {
				return '';
			}
			return 'Datum oddaje je obvezen';
		},
		state_responsible_mechanic_take () {
			if (this.mode === this.mode_TAKE2) {
				if (this.hotelStoritev.responsible_mechanic_take && this.hotelStoritev.responsible_mechanic_take.length > 0) {
					return true;
				}
				return false;
			}
			return '';
		},
		invalidFeedback_responsible_mechanic_take () {
			if (this.mode === this.mode_TAKE2 && !this.formDisabled) {
				if (this.hotelStoritev.responsible_mechanic_take) {
					this.hideAlert();
					return '';
				}
				return 'Odgovoren mehanik je obvezen';
			}
			return '';
		},
		state_date_take () {
			if (this.mode === this.mode_TAKE2) {
				if (this.hotelStoritev.date_take) {
					return true;
				}
				return false;
			}
			return true;
		},
		invalidFeedback_date_take () {
			if (this.mode === this.mode_TAKE2 && !this.formDisabled) {
				if (this.hotelStoritev.date_take) {
					return '';
				}
				return 'Datum izdaje je obvezen';
			}
			return '';
		},
		validateForm: function () {
			if (!this.state_dimensions_width || !this.state_dimensions_height || !this.state_dimensions_diameter) {
				return false;
			}
			if ((this.mode === this.mode_GIVE1 || this.mode === this.mode_SWITCH3) && this.state_responsible_mechanic_give && this.state_date_give && this.state_date_take) {
				return true;
			} else if (this.mode === this.mode_TAKE2 && this.state_responsible_mechanic_take && this.state_date_give && this.state_date_take) {
				return true;
			} else if (this.mode === this.mode_EDITING4 && this.state_responsible_mechanic_give && this.state_date_give) {
				return true;
			}
			return false;
		},
		formDisabled: function () {
			if (settings.isModerator(this.user.role) || settings.isAdmin(this.user.role) || settings.isSkrbnikGum(this.user.role)) {
				return false;
			} else {
				return true;
			}
		},
		modalSize () {
			return 'lg'
		},
		mainCardHeader () {
			if (this.mode === this.mode_GIVE1 || this.mode === this.mode_SWITCH3) {
				return 'Podatki o oddaji';
			} else if (this.mode === this.mode_TAKE2) {
				return 'Podatki o izdaji';
			} else if (this.mode === this.mode_EDITING4) {
				return 'Podatki o storitvi';
			} else {
				return 'Neznan način'
			}
		},
		manufacturer_Options () {
			if (this.hotelStoritevDistincManufacturers && this.hotelStoritevDistincManufacturers.length > 0) {
				return this.hotelStoritevDistincManufacturers;
			} else {
				if (this.manufacturer_initOptions == null) {
					this.loadManufacturers();
				}
				return this.manufacturer_initOptions;
			}
		},
		state_dimensions_width () {
			if (this.hotelStoritev.dimensions.width && this.hotelStoritev.dimensions.width.length > 3) {
				return false;
			}
			return true;
		},
		invalidFeedback_dimensions_width () {
			if (this.hotelStoritev.dimensions.width && this.hotelStoritev.dimensions.width.length > 3) {
				return 'Neveljavna širina';
			}
			return '';
		},
		state_dimensions_height () {
			if (this.hotelStoritev.dimensions.heigth && this.hotelStoritev.dimensions.heigth.length > 2) {
				return false;
			}
			return true;
		},
		invalidFeedback_dimensions_height () {
			if (this.hotelStoritev.dimensions.heigth && this.hotelStoritev.dimensions.heigth.length > 2) {
				return 'Neveljavna višina';
			}
			return '';
		},
		state_dimensions_diameter () {
			if (this.hotelStoritev.dimensions.diameter && this.hotelStoritev.dimensions.diameter.length > 2) {
				return false;
			}
			return true;
		},
		invalidFeedback_dimensions_diameter () {
			if (this.hotelStoritev.dimensions.diameter && this.hotelStoritev.dimensions.diameter.length > 2) {
				return 'Neveljaven premer';
			}
			return '';
		}
	},
	created () {
	}
}
</script>

<style scoped>
.ma_pos {
	text-align: end;
}
.infoCard {
	min-height: 240px;
}
.nav {
	border-top: 1px solid #c8ced3;
	padding-top: 1rem;
}
.pagination {
	margin-left: 1rem;
	margin-right: 1rem;
}
.page-link.rows_total {
	text-align: center;
	border-radius: 5px;
	width: 120px;
}
</style>
<style>
.comment {
	background-color:gainsboro;
	border-radius: 5px;
	padding: 5px;
}
.tdHotelKomentarCreatedAt {
	width: 150px;
}
.tdHotelKomentarContent {
	max-width: 300px;
}
.tdHotelKomentarUser {
	width: 150px;
}
</style>


// WEBPACK FOOTER //
// src/components/HotelGum/Modals/EditHotelStoritevModal.vue